import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "श्री लुकेश का. लोखंडे	 ", designation: "ग्रामपंचायत बोरी ", phone: "+91 ------", imageUrl: "/images/lukesh.jpeg" },
  { name: "श्री प्रविण पु. चौधरी", designation: "ग्रामपंचायत बोरी" , phone: "+91 --", imageUrl: "/images/pravin.jpeg" },
  { name: "सौ. चंदाताई शि. धाटे", designation: "ग्रामपंचायत बोरी",  phone: "+91 --", imageUrl: "/images/chanda.jpeg" },
  { name: "सौ. दीक्षाताई भा. डोंगरे", designation: "ग्रामपंचायत बोरी", phone: "+91 --", imageUrl: "/images/diksha.jpeg" },
  { name: "सौ. कांताबाई रा. बैगणे", designation: " ग्रामपंचायत बोरी ",phone: "+91 --", imageUrl: "/images/kanta.jpeg" },
  { name: "सौ. संगिता वि.कडवे", designation: "ग्रामपंचायत बोरी", phone: "+91 --", imageUrl: "/images/sangita.jpeg" },
];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
